//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pdpComponentMixin from '~/mixins/pdpComponentMixin'

export default {
  mixins: [pdpComponentMixin],
  props: {
    showLensTechWarning: { type: Boolean, default: false }
  },
  data: () => ({
    isMounted: false,
    customiserMaxHeight: 0,
    customiserMarginTop: 0,
    activeCustomiserTabIndex: 0
  }),
  computed: {
    isMinimumPrice () {
      return this.allowLensTechFiltering && !this.lensTechSelected
    },
    limitedEditionProductName () {
      return this.productName.replace(/Vanguards|Revolts|Snipers|Classics|Sierras|Renegades|Vulcans|Velans|Snipers|³|™/ig, '').trim()
    },
    baseProductName () {
      const baseProductName = this.getProductName(this.skuPrefix)
      if ((this.ecomProduct.name || '').toLowerCase().includes('signature') || this.lePartDetails.isSignatureSeries) return `${baseProductName} Signature Series`
      return `${baseProductName} Limited Edition`
    },
    swatchSelectVariants () {
      return this.bestsellers.map((bestseller) => {
        return {
          ...bestseller,
          swatch: this.buildSwatch(bestseller.sku),
          swatchIcon: this.getSwatchIcon(bestseller)
        }
      })
    },
    activeSwatchIndex () {
      return this.swatchSelectVariants.findIndex(this.isVariantSelected)
    }
  },
  watch: {
    customiserMode () {
      this.setCustomiserStyles()
    },
    activeCustomiserTabIndex () {
      this.$emit('change-customiser-tab', this.activeCustomiserTabIndex)
    }
  },
  mounted () {
    this.isMounted = true
    this.handlePageUpdate = this.throttleFunction(this.handlePageUpdate, 250)
    this.setCustomiserStyles()
  },
  updated () {
    this.handlePageUpdate()
  },
  methods: {
    getPartsFromSku: sku => (sku || '-').split('-').slice(1),
    getLensPartFromSku (sku) {
      return this.getPartsFromSku(sku).find(part => part.match(/.{1,2}le_/))
    },
    getFramePartFromSku (sku) {
      return this.getPartsFromSku(sku).find(part => part.match(/.{1,2}f_/))
    },
    getLensPartName (sku, lensPartOverride) {
      const lensPart = this.getLensPartFromSku(sku)
      return (this.$store.getters['product/allChoices'][lensPartOverride || lensPart] || {}).name || ''
    },
    buildSwatch (sku) {
      return [
        this.getSwatch(this.getFramePartFromSku(sku)),
        this.getSwatch(this.getLensPartFromSku(sku))
      ]
    },
    normaliseSku (sku) {
      sku = this.getSKUWithLensTech(sku, this.lensTech)
      if (this.frameType) sku = this.getSkuWithFrameType(sku, this.frameType)
      return sku
    },
    isVariantSelected (variant) {
      const variantSku = this.normaliseSku(variant[this.bestsellerSkuField] || variant.sku || '')
      const variantSkuSorted = (variantSku || '').split('-').sort((a, b) => a.localeCompare(b)).join('-')
      const currentSkuSorted = (this.sku || '').split('-').sort((a, b) => a.localeCompare(b)).join('-')
      return variantSkuSorted === currentSkuSorted
    },
    handlePageUpdate () {
      this.setCustomiserStyles()
    },
    setCustomiserStyles () {
      this.setCustomiserMaxHeight()
      this.setCustomiserMarginTop()
    },
    setCustomiserMaxHeight () {
      if (!this.customiserMode) {
        this.customiserMaxHeight = 0
        return
      }

      if (!this.isMounted || !this.$refs.customiser) {
        this.customiserMaxHeight = 0
        setTimeout(this.setCustomiserMaxHeight, 200) // Try again in 200ms
        return
      }

      const customiserContents = this.$refs.customiser.$el.querySelector('.ProductCustomiser__inner')
      const computedStyles = getComputedStyle(customiserContents)
      this.customiserMaxHeight = `calc(${computedStyles.height} + ${computedStyles.marginTop} + ${computedStyles.marginBottom} + 20px)`
    },
    setCustomiserMarginTop () {
      if (!this.customiserMode) {
        this.customiserMarginTop = 0
        return
      }

      if (!this.isMounted || !this.$el) {
        this.customiserMarginTop = 0
        setTimeout(this.setCustomiserMarginTop, 200) // Try again in 200ms
        return
      }

      const aboveCustomiserContents = this.$el.querySelector('.ProductInfoPanel__above-customiser')
      const computedStyles = getComputedStyle(aboveCustomiserContents)
      this.customiserMarginTop = `calc(-1 * (${computedStyles.height} + ${computedStyles.marginTop} + ${computedStyles.marginBottom}))`
    },
    getSwatchIcon (bestseller) {
      let swatchIcon = (bestseller.swatchIconOverride || {}).url || null

      // Get swatch icon from file for LE parts
      if (!swatchIcon && bestseller.buttonImg) {
        try {
          swatchIcon = bestseller.buttonImg
            ? require(`~/assets/images/${bestseller.buttonImg}`)
            : require(`~/assets/images/limited-edition/icon-${bestseller.limitedEditionPart}.png`)
        } catch (error) {
          this.$sentry.captureException(error)
          console.error(error)
        }
      }
      
      // Load swatch icon from file for LE products that aren't in dato
      if (!swatchIcon && bestseller.isLE) {
        try {
          swatchIcon = require(`~/assets/images/limited-edition/icon-${bestseller.sku}.png`)
        } catch (error) {
          this.$sentry.captureException(error)
          console.error(error)
        }
      }

      return swatchIcon
    },
    handleCustomiserTabChange (idx, part) {
      this.activeCustomiserTabIndex = idx
      this.$emit('change-customiser-tab', part)
    },
    handleCustomiseButtonClick () {
      if (this.leMode) return this.$emit('select-swatch', (this.swatchSelectVariants[0] || {}).sku)
      this.$emit('update:customiserMode', !this.customiserMode)
    }
  }
}
